import React, { useEffect, useState } from "react";
import API_BASE_URL from "../config";
import "./MaintenanceNotice.css";

const MaintenanceNotice = () => {
  const [maintenance, setMaintenance] = useState(null);

  useEffect(() => {
    fetchUpcoming();
  }, []);

  const fetchUpcoming = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/maintenance/upcoming`);
      const data = await res.json();

      if (data.success && data.maintenance) {
        setMaintenance(data.maintenance);
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (!maintenance) return null;

  return (
    <div className="maintenance-notice">
      🚧 <b>Scheduled Maintenance:</b>{" "}
      {new Date(maintenance.startTime).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit"
      })}
      {" – "}
      {new Date(maintenance.endTime).toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit"
      })}
    </div>
  );
};

export default MaintenanceNotice;
